import { render, staticRenderFns } from "./CustomFieldComponent.vue?vue&type=template&id=3ba40420&"
import script from "./CustomFieldComponent.vue?vue&type=script&lang=js&"
export * from "./CustomFieldComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldComponent.vue?vue&type=style&index=0&id=3ba40420&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports